import { useHttp } from './http';

const http = useHttp('data_quality');

export default {
  search: params => http.get('checks', { params }),
  getStatistics: () => http.get('overview_stats'),
  getBusinessRules: () => http.get('check_definitions'),
};
